<template>
	<div class="container">
		<div class="m_sub_top">
			<div class="top_content">
				<h2 class="headline_m type2">
					{{ $t('rtr_business-operation-pay.title1') }}
				</h2>
				<p class="body_m">
					{{ $t('rtr_business-operation-pay.text1') }}
				</p>
				<div class="button_area">
					<button class="button_bg_red mr_10" @click="toLogin">
						{{ $t('button.signup') }}
					</button>
					<button class="button_bg_black" @click="notYet">
						{{ $t('button.down') }}
					</button>
				</div>
			</div>
		</div>
		<div class="bottom_area">
			<div class="catch_box mb_16 tal">
				<p class="title_l fc_white mb_16">
					{{ $t('rtr_business-operation-pay.title2') }}<br />
					{{ $t('rtr_business-operation-pay.title3') }}
				</p>
				<p class="body_m fc_white">
					{{ $t('rtr_business-operation-pay.text2') }}
				</p>
			</div>
			<div class="bottom_box mb_16">
				<p class="headline_s type2 mb_16 pt_40">
					{{ $t('rtr_business-operation-pay.title4') }}<br />
					{{ $t('rtr_business-operation-pay.title5') }}
				</p>
			</div>
		</div>
	</div>
</template>

<script>
import '@/assets/css/sub.m.css';

export default {
	name: 'Platform.m.m',
	setup() {
		return {};
	},
	methods: {
		notYet() {
			alert(this.$t('alert.not_yet'));
		},
		toLogin() {
			this.$router.push({ name: 'auth-login' });
		},
	},
};
</script>
<style scoped></style>
